import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import ModalInnerWrapper from './shared/designElements/ModalInnerWrapper';
import DeleteConfirmation from './shared/designElements/DeleteConfirmation';
import { connect } from 'react-redux';
import { performApiRequest, getResultData, invalidateApiDataRequest, getApiDataRequest } from '../redux/apiData';
import { updateModalOpenState, clearModalState } from '../redux/modal';
import withMatch from '@/hocs/withMatch';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var wishListId = ownProps.wishListId;
  return {
    resultWishList: getResultData(state.apiData, 'duplicateWishList', {
      projectSlug: String(ownProps.match.params.projectSlug),
      wishListId: wishListId
    }),
    duplicateWishListRequest: getApiDataRequest(state.apiData, 'duplicateWishList', {
      projectSlug: String(ownProps.match.params.projectSlug),
      wishListId: wishListId
    }),
    deleteWishListRequest: getApiDataRequest(state.apiData, 'deleteWishList', {
      projectSlug: String(ownProps.match.params.projectSlug),
      wishListId: wishListId
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    deleteDef: function deleteDef(projectSlug, wishListId) {
      dispatch(performApiRequest('deleteWishList', {
        projectSlug: projectSlug,
        wishListId: wishListId
      }));
      dispatch(invalidateApiDataRequest('getWishLists', {
        projectSlug: projectSlug
      }));
      setTimeout(function () {
        dispatch(updateModalOpenState(false));
        dispatch(clearModalState());
      }, 500);
    },
    copyDef: function copyDef(projectSlug, wishListId) {
      dispatch(performApiRequest('duplicateWishList', {
        projectSlug: String(projectSlug),
        wishListId: wishListId
      }));
      dispatch(invalidateApiDataRequest('getWishLists', {
        projectSlug: String(projectSlug)
      }));
      dispatch(invalidateApiDataRequest('duplicateWishList', {
        projectSlug: projectSlug,
        wishListId: wishListId
      }));
    },
    onClose: function onClose() {
      dispatch(updateModalOpenState(false));
      dispatch(clearModalState());
    }
  };
};
var DeleteWishListModal = /*#__PURE__*/function (_Component) {
  function DeleteWishListModal() {
    var _this;
    _classCallCheck(this, DeleteWishListModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DeleteWishListModal, [].concat(args));
    _defineProperty(_this, "deleteWishList", function () {
      var _this$props = _this.props,
        deleteDef = _this$props.deleteDef,
        projectSlug = _this$props.projectSlug,
        wishListId = _this$props.wishListId;
      deleteDef(projectSlug, wishListId);
    });
    _defineProperty(_this, "copyWishList", function () {
      var _this$props2 = _this.props,
        copyDef = _this$props2.copyDef,
        projectSlug = _this$props2.projectSlug,
        wishListId = _this$props2.wishListId;
      copyDef(projectSlug, wishListId);
    });
    _defineProperty(_this, "closeModal", function () {
      _this.props.onClose();
    });
    return _this;
  }
  _inherits(DeleteWishListModal, _Component);
  return _createClass(DeleteWishListModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
        duplicateWishListRequest = _this$props3.duplicateWishListRequest,
        resultWishList = _this$props3.resultWishList,
        match = _this$props3.match,
        router = _this$props3.router;
      if ((duplicateWishListRequest === null || duplicateWishListRequest === void 0 ? void 0 : duplicateWishListRequest.networkStatus) === 'success') {
        router === null || router === void 0 || router.push("/".concat(String(match.params.projectSlug), "/closed/homestudio/").concat(resultWishList.id));
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
        deleteWishListRequest = _this$props4.deleteWishListRequest,
        duplicateWishListRequest = _this$props4.duplicateWishListRequest;
      var lastOwnWishlist = this.props.bnr === this.props.ownBNR && this.props.ownBNRWishlists === 1;
      var duplicateIsLoading = (duplicateWishListRequest === null || duplicateWishListRequest === void 0 ? void 0 : duplicateWishListRequest.networkStatus) === 'ready';
      var deleteIsLoading = (deleteWishListRequest === null || deleteWishListRequest === void 0 ? void 0 : deleteWishListRequest.networkStatus) === 'loading';
      return __jsx(ModalInnerWrapper, {
        "data-id": "components_DeleteWishListModal_ModalInnerWrapper"
      }, lastOwnWishlist && this.props.type === 'delete' && __jsx(DeleteConfirmation, {
        title: "Dit is het laatste ontwerp van jouw woning",
        description: "Daarom kan je dit ontwerp niet verwijderen.",
        submitButtonLabel: "OK",
        lastOne: lastOwnWishlist,
        submitFn: this.closeModal,
        "data-id": "components_DeleteWishListModal_DeleteConfirmation"
      }), !lastOwnWishlist && this.props.type === 'delete' && __jsx(DeleteConfirmation, {
        title: "Weet je zeker dat je het woonontwerp \u2018<span>".concat(this.props.title, "</span>\u2019 wilt verwijderen?"),
        description: "Deze actie kan niet ongedaan worden gemaakt.",
        submitButtonLabel: "Verwijderen",
        submitFn: this.deleteWishList,
        cancelButtonLabel: "Annuleren",
        cancelFn: this.closeModal,
        loading: deleteIsLoading,
        disabled: deleteIsLoading,
        "data-id": "components_DeleteWishListModal_DeleteConfirmation_2"
      }), this.props.type === 'confirmation' && __jsx(DeleteConfirmation, {
        title: "Helaas, deze woning is niet meer beschikbaar",
        description: "Deze woning is verkocht en inmiddels gekoppeld aan een toekomstig bewoner. Om die reden kun je woonontwerpen die je voor deze woning hebt gemaakt niet meer bewerken. Kies voor 'Maak een nieuw woonontwerp' om de mogelijkheden van andere woningen te bekijken en ontdek welke woning het beste bij je past.",
        submitButtonLabel: "Ik begrijp het",
        submitFn: this.closeModal,
        "data-id": "components_DeleteWishListModal_DeleteConfirmation_3"
      }), this.props.type === 'copy' && __jsx(DeleteConfirmation, {
        title: "Je staat op het punt om een kopie te maken van het woonontwerp \u2018<span>".concat(this.props.title, "</span>\u2019"),
        description: "Hiermee gebruik je alle opties en woonwensen die je in dit ontwerp hebt opgeslagen om een nieuw ontwerp te starten.",
        submitButtonLabel: "Kopi\xEBren",
        submitFn: this.copyWishList,
        cancelButtonLabel: "Annuleren",
        cancelFn: this.closeModal,
        loading: duplicateIsLoading,
        disabled: duplicateIsLoading,
        "data-id": "components_DeleteWishListModal_DeleteConfirmation_4"
      }));
    }
  }]);
}(Component);
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(DeleteWishListModal));